import { render, staticRenderFns } from "./ShapeTeaser.vue?vue&type=template&id=f45e49fc"
import script from "./ShapeTeaser.vue?vue&type=script&lang=js"
export * from "./ShapeTeaser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports